import { push } from 'react-router-redux';
// import gaPush, { gaSetUser } from '../globs/utils/google-analytics';
import ajaxProxy from '../globs/ajax-proxy';

export const NOTIFICATION_RECIEVED = 'app-notifications/recieved';
export const NOTIFICATION_VIEWED = 'app-notifications/viewed';

export default function appNotifications() {
//   gaSetUser(); // Reset the GA user id
//   gaPush('event', {
//     category: 'Notifications',
//     action: 'Notifications',
//   });

  return (dispatch) => {
    dispatch(push('/notifications-settings'));
  };
}

export function appNotificationReceived(payload) {
  return (dispatch) => {
    dispatch(notificationRecieved(payload));
  };
}

export function appNotificationViewed(payload) {
  return (dispatch) => {
    ajaxProxy.trackNotificationAction(payload)
      .then(() => {
        dispatch(notificationViewed());
      })
      .catch(() => {});
  };
}

function notificationRecieved(payload) {
  return {
    type: NOTIFICATION_RECIEVED,
    payload,
  };
}

function notificationViewed() {
  return {
    type: NOTIFICATION_VIEWED,
    payload: {},
  };
}
